import { withArtDirection, getImage } from 'gatsby-plugin-image';

export const getImagesWithArtDirection = image => {
  const adaptives = [];

  if (image?.mobile) {
    adaptives.push({
      media: '(max-width: 544px)',
      image: getImage(image.mobile),
    });
  }
  if (image?.tablet) {
    adaptives.push({
      media: '(max-width: 1024px)',
      image: getImage(image.tablet),
    });
  }

  return withArtDirection(getImage(image.desktop), adaptives);
};
